// extracted by mini-css-extract-plugin
export default {"modalContent":"AddRefundModal_modalContent__ZuDu-"};